import { render, staticRenderFns } from "./permission-tooltip.vue?vue&type=template&id=76800659&scoped=true&"
import script from "./permission-tooltip.vue?vue&type=script&lang=js&"
export * from "./permission-tooltip.vue?vue&type=script&lang=js&"
import style0 from "./permission-tooltip.vue?vue&type=style&index=0&id=76800659&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76800659",
  null
  
)

export default component.exports